import React, { useContext } from 'react';

import HolidaysTable from '@/components/Navbar/SettingsModal/CompanySettingsTab/CompanyHolidaysSection/HolidaysTable';
import { ProjectContext } from '@/Contexts/Project/Context';
import { type CompanyHoliday } from '@/Contexts/Settings/Context';

const ProjectHolidaysSection: React.FC = () => {
  const { project, defaultCompanySettings, onHolidaysChange } = useContext(ProjectContext);

  const rawHolidays = project.settings?.find((s) => s.name === 'project_holidays')?.value;
  const holidays: CompanyHoliday[] = JSON.parse(
    rawHolidays !== undefined ? rawHolidays : defaultCompanySettings?.companyHolidays || '[]',
  );

  return <HolidaysTable holidays={holidays} onChange={onHolidaysChange} titlePrefix="Project" />;
};

export default ProjectHolidaysSection;
